var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 2.00016C13.158 2.00016 15.9747 3.77516 17.3497 6.5835C15.9747 9.39183 13.158 11.1668 9.99967 11.1668C6.84134 11.1668 4.02467 9.39183 2.64967 6.5835C4.02467 3.77516 6.84134 2.00016 9.99967 2.00016ZM9.99967 0.333496C5.83301 0.333496 2.27467 2.92516 0.833008 6.5835C2.27467 10.2418 5.83301 12.8335 9.99967 12.8335C14.1663 12.8335 17.7247 10.2418 19.1663 6.5835C17.7247 2.92516 14.1663 0.333496 9.99967 0.333496ZM9.99967 4.50016C11.1497 4.50016 12.083 5.4335 12.083 6.5835C12.083 7.7335 11.1497 8.66683 9.99967 8.66683C8.84967 8.66683 7.91634 7.7335 7.91634 6.5835C7.91634 5.4335 8.84967 4.50016 9.99967 4.50016ZM9.99967 2.8335C7.93301 2.8335 6.24967 4.51683 6.24967 6.5835C6.24967 8.65016 7.93301 10.3335 9.99967 10.3335C12.0663 10.3335 13.7497 8.65016 13.7497 6.5835C13.7497 4.51683 12.0663 2.8335 9.99967 2.8335Z",
    fill: "#6A6C71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.832c1ccf2934ad9acc549d10aee1e63d.svg";
export { ForwardRef as ReactComponent };